/**
 * AcaoConcurso.
 */
export class AcaoConcurso {
	id?: number;
	codigo_acao?: number;

	constructor(id?: number, codigo_acao?: number) {
		this.id = id;
		this.codigo_acao = codigo_acao;
	}
}
